import React from 'react';
import { isMobile } from '@pascal/pascal-core';
import boxMoney from '../../../../assets/images/bonus-island/img-box-money.png';
import winMoney from '../../../../assets/images/bonus-island/img-win-money.png';
import bonusIslandDefaultImage from '../../../../assets/images/bonus-island/bonus-en.png';

export const BonusIslandRow = ({
  winText,
  imageSrc = bonusIslandDefaultImage,
  winAmount,
  currencyCode,
  handleOpenBonusIsland,
  isChangePlacesOfAmountAndCurrencyCode,
}) => {
  return (
    <div className='bonus-island-container'>
      <div className={`bonus-island-wr ${winAmount ? 'win' : ''}`} onClick={handleOpenBonusIsland}>
        {!winAmount && (
          <>
            {!isMobile() ? (
              <div className='left-bonus-island'>
                <img src={imageSrc} alt='' />
              </div>
            ) : (
              <></>
            )}
            <div className='right-bonus-island'>
              <img src={boxMoney} alt='' />
            </div>
          </>
        )}
      </div>
      {!!winAmount && (
        <div className='bonus-isl-win-wr'>
          <div className='bonus-isl-win-inside'>
            <div className='bonus-isl-win-left-img'>
              <img src={winMoney} alt='' />
            </div>
            <div className='bonus-isl-win-inside-left'>
              <p className='bonus-isl-win-inside-left-win'>{winText}!!!</p>
            </div>
            <div className='bonus-isl-win-inside-left'>
              <div className='b-i-win-ins-left-con'>
                <p className='b-i-p-win'>
                  {isChangePlacesOfAmountAndCurrencyCode ? (
                    <>
                      <span>{currencyCode}</span>
                      {winAmount}
                    </>
                  ) : (
                    <>
                      {winAmount}
                      <span>{currencyCode}</span>
                    </>
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
